import { FC } from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';

const StyledSelect = styled.select`
  ${tw`flex-none bg-white/80 border border-slate-300 text-xs rounded-lg p-1.5 leading-none text-slate-800 shadow-slate-300 outline-none`};

  &:focus {
    ${tw`bg-white shadow-[0_0_0_4px_rgb(var(--color-primary)_/_0.2)] border-primary`};
  }
`;

interface Props {
  options: {
    label: string;
    value: string;
  }[];
  id?: string;
  selectedValue?: string | number;
  className?: string;
  handleChange: (value: string | number) => void;
}

const Select: FC<Props> = ({
  id,
  selectedValue,
  options,
  className,
  handleChange,
}) => (
  <StyledSelect
    id={id}
    value={selectedValue}
    onChange={(e) => handleChange(e.target.value)}
    className={className}
  >
    {options.map((item) => (
      <option key={item.value} value={item.value}>
        {item.label}
      </option>
    ))}
  </StyledSelect>
);

export default Select;
